import React, { useState } from 'react'
import Layout from '../components/Layout'
import Table from '../components/common/Table'
import { useLoad } from '../hooks/request'
import { IRRIGATION_TYPE_LIST } from '../urls'
import Button from '../components/common/Button'
import { useModal } from '../hooks/modal'
import { useUser } from '../hooks/user'
import { PermissionDenied } from '../components/PermissionDenied'
import { roleMain } from '../utils/role'
import useTrans from '../hooks/trans'
import SeasonTabs from '../components/SeasonTabs'
import IrrigationTypeCreate from '../components/IrrigationTypeCreate'
import IrrigationTypeItem from '../components/IrrigationTypeItem'

export default function IrrigationType() {
    const t = useTrans()
    const [user] = useUser()
    const [page, setPage] = useState(1)
    const types = useLoad({ url: IRRIGATION_TYPE_LIST, params: { page, size: 100 } }, [page])

    const [showCreateModal, hideCreateModal] = useModal(
        <IrrigationTypeCreate
            onCancel={() => hideCreateModal()}
            onSuccess={() => {
                hideCreateModal()
                types.request()
            }}
        />,
    )

    if (!roleMain.includes(user.role)) {
        return <PermissionDenied />
    }

    return (
        <Layout>
            <SeasonTabs />

            <div className="is-flex is-justify-content-space-between my-5">
                <h1 className="title has-text-weight-normal">
                    <span>{t('irrigationType')}</span>
                </h1>

                {user.role === 'main' ? (
                    <Button
                        className="is-link is-outlined"
                        text={t('add')}
                        icon="ion-md-add"
                        onClick={showCreateModal}
                    />
                ) : null}
            </div>

            <Table
                loading={types.loading}
                activePage={page}
                pageSize={100}
                onPageChange={setPage}
                totalCount={types.response ? types.response.count : 0}
                columns={{ name: t('name'), type: t('type'), actions: '' }}
                items={types.response ? types.response.results : []}
                renderItem={(item) => (!item.isArchive ? (
                    <IrrigationTypeItem
                        onSuccess={types.request}
                        item={item}
                        key={item.id} />
                ) : null)} />
        </Layout>
    )
}
